import {all, call, fork, put, select, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import {deleto, get, post} from 'bukku/shared/ApiService';
import ShoeboxActions from 'bukku/redux/Shoebox/actions';

// Read all
export function* readAllFilesRequest() {
    yield takeEvery(actions.FILE_READ_ALL_REQUEST, function* ({ payload }, context) {
        try {
            // const paramString = queryString.stringify(payload);
            // let searchString = '';
            // if (paramString)
            // searchString = `?${paramString}`;

            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, `/files`, payload, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.FILE_READ_ALL_SUCCESS,
                globalFiles: data.files,
                pagination: data.paging,
            });
        }
        catch (error) {
            yield put({
                type: actions.FILE_READ_ALL_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}

export function* readAllFilesSuccess() {
    yield takeEvery(actions.FILE_READ_ALL_SUCCESS, () => {});
}

export function* readAllFilesError() {
    yield takeEvery(actions.FILE_READ_ALL_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export function* readFileRequest() {
    yield takeEvery(actions.FILE_READ_FILE_REQUEST, function* ({ fileId }, context) {
        try {
            yield put({type: AppActions.APP_START_PULLING});
            const response = yield call(get, `/files/${fileId}`, null, context);
            const data = yield response.data;

            //OK
            yield put({
                type: actions.FILE_READ_FILE_SUCCESS,
                file: data.file,
            });
        }
        catch (error) {
            yield put({
                type: actions.FILE_READ_FILE_ERROR,
                error,
            });
        }
        finally {
            yield put({type: AppActions.APP_STOP_PULLING});
        }
    });
}

export function* readFileSuccess() {
    yield takeEvery(actions.FILE_READ_FILE_SUCCESS, () => {});
}

export function* readFileError() {
    yield takeEvery(actions.FILE_READ_FILE_ERROR, function* ({error}) {
        yield message.error(error.message);
    });
}

// Delete field
export function* deleteFilesRequest() {
    yield takeEvery(actions.FILE_DELETE_FILES_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(deleto, '/files', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.FILE_DELETE_FILES_SUCCESS,
                deletedIds: data.deleted_ids,
            });
        }
        catch (error) {
            yield put({
                type: actions.FILE_DELETE_FILES_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* deleteFilesSuccess() {
    yield takeEvery(actions.FILE_DELETE_FILES_SUCCESS, function* () {
    // yield message.success(t`The file(s) are deleted.`);
    });
}
export function* deleteFilesFail() {
    yield takeEvery(actions.FILE_DELETE_FILES_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export function* readFloatingViewerFileRequest() {
    yield takeEvery(actions.FILE_OPEN_FLOATING_VIEWER_REQUEST, function* ({ file }, context) {
        try {
            const response = yield call(get, `/files/${file.id}`, null, context);
            const data = yield response.data;

            //OK
            yield put({
                type: actions.FILE_OPEN_FLOATING_VIEWER_SUCCESS,
                file: data.file,
            });
        }
        catch (error) {
            yield put({
                type: actions.FILE_OPEN_FLOATING_VIEWER_ERROR,
                error,
            });
        }
    });
}
export function* rotateFileRequest() {
    yield takeEvery(actions.FILE_ROTATE_REQUEST, function* ({ fileId, rotateDirection }) {
        try {
            const response = yield call(post, `/files/${fileId}/rotate`, {
                rotate: rotateDirection,
            });
            const data = yield response.data;
            //OK
            yield put({
                type: actions.FILE_ROTATE_SUCCESS,
                rotatedFile: {
                    file: data.file,
                },
            });
        }
        catch (error) {
            yield put({
                type: actions.FILE_ROTATE_ERROR,
                error,
            });
        }
    });
}
export function* rotateFileSuccess() {
    yield takeEvery(actions.FILE_ROTATE_SUCCESS, function* ({ rotatedFile }) {
        const currentShoeboxItem = yield select(state => state.Shoebox.item);

        // only replace Shoebox Preview if still viewing the same shoebox item before rotate
        if (currentShoeboxItem.file_id === rotatedFile.file.id) {
            yield put({
                type: ShoeboxActions.SHOEBOX_SET_ITEM,
                item: rotatedFile, // partial update of 'file' key in Shoebox.item
            });
        }
    });
}
export function* rotateFileError() {
    yield takeEvery(actions.FILE_ROTATE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(readAllFilesRequest),
        fork(readAllFilesSuccess),
        fork(readAllFilesError),
        fork(readFileRequest),
        fork(readFileSuccess),
        fork(readFileError),
        fork(deleteFilesRequest),
        fork(deleteFilesSuccess),
        fork(deleteFilesFail),
        fork(readFloatingViewerFileRequest),
        fork(rotateFileRequest),
        fork(rotateFileSuccess),
        fork(rotateFileError),
    ]);
}
